<template>
  <div class="container-fluid">
    <b-card class="card-transparent-background mt-3 mb-2">
      <b-card-title class="card-title-doorder my-1"
        >Retailer Application NO. {{ retailer.id }}</b-card-title
      >
    </b-card>
    <b-card no-body class="card-transparent-background mt-0">
      <b-card-body class="p-0">
        <CompanyDetails
          type="profile" status="request"
          :company_name="retailer.name"
          :company_website="retailer.company_website"
          :business_type="retailer.business_type"
          :number_business_locations="retailer.locations_count"
        />
        <LocationDetails
          type="profile"
          :locations="retailer.locations"
          class="mt-5"
        />
        <ContactDetails
          type="profile"
          :locations="retailer.locations"
          :contacts.sync="retailer.contacts"
          class="mt-5"
        />
      </b-card-body>
    </b-card>
    <b-row class="justify-content-center">
      <b-col lg="3" md="3" sm="4" class=" text-center">
        <b-button
        v-if="!is_loading"
          type="button"
          variant="doorder-primary"
          class="btn-bumblebee btn-doorder w-100 mb-1"
          @click="clickAcceptRetailerRequest"
          >Accept</b-button
        >
          <b-button
                      type="button"
                      disabled
                      variant="doorder-primary"
                      class="
                        btn-bumblebee btn-doorder  w-100 mb-1
                      "
                      v-else
                    >
                      <b-spinner
                        small
                        label="Small Spinner"
                        variant="light"
                      ></b-spinner>
                      Loading</b-button
                    >
      </b-col>

      <b-col lg="3" md="3" sm="4" class=" text-center">
        <b-button
        type="button"
          variant="doorder-danger-outline"
          class="btn-bumblebee btn-doorder w-100 mb-1"
           v-b-modal.reject-retailer-modal-doorder
          >Reject</b-button
        >
      </b-col>
    </b-row>
    <RejectRetailerModal :retailer_id="retailer.id"/>
  </div>
</template>

<script>
import $ from "jquery";
import axios from "axios";
import moment from "moment";

import CompanyDetails from "./profile_details_components/CompanyDetails.vue";
import LocationDetails from "./profile_details_components/LocationDetails.vue";
import ContactDetails from "./profile_details_components/ContactDetails.vue";
import PaymentDetails from "./profile_details_components/PaymentDetails.vue";

import RejectRetailerModal from "./RejectRetailerModal.vue"

export default {
  name: "DoorderRetailerSingleRequest",
  components: {
    CompanyDetails,
    LocationDetails,
    ContactDetails,
    PaymentDetails,
    RejectRetailerModal
  },
  data() {
    return {
      client_name: "DOORDER",
      retailer: null,
      is_loading: false
    };
  },
  mounted() {
    this.getRetailerRequestData();
  },
  methods: {
    getRetailerRequestData() {
      axios
        .get("/retailer/request/" + this.$route.params.id, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            client: this.client_name,
            Authorization:
              "Bearer " +
              JSON.parse(window.localStorage.getItem("user")).access_token,
          },
        })
        .then((response) => {
          console.log(response);
          this.retailer = response.data.retailer;
          // this.events = response.data;
          //   this.setEventData(response.data);
        });
    },
    clickAcceptRetailerRequest() {
      console.log("click accept retailer", this.$route.params.id);

      this.is_loading = true;
      let formData = new FormData();
      formData.append("client", this.client_name);
      formData.append("id", this.retailer.id);
      formData.append("action", "accept");

      axios
        .post("retailer/accept-reject", formData, {
          headers: {
            client: this.client_name,
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization:
              "Bearer " +
              JSON.parse(window.localStorage.getItem("user")).access_token,
          },
        })
        .then((response) => {
          console.log(response);
          this.$fire({
            // title: "Title",
            text: response.data.message,
            type: "success",
             customClass: {
              container: "swal-alert-doorder",
              confirmButton:
                "btn btn-bumblebee btn-doorder btn-doorder-primary btn-doorder-submit",
              cancelButton:
                "btn btn-bumblebee btn-doorder btn-doorder-danger-outline btn-doorder-submit",
            },
            // timer: 3000,
          }).then((r) => {
            // console.log(r.value);
          });
          this.is_loading = false;
          
        })
        .catch((error) => {
          console.log(error.response);
          this.is_loading = false;
          this.$fire({
            // title: "Title",
            text: error.response.data.error,
            type: "error",
            customClass: {
              container: "swal-alert-doorder",
              confirmButton:
                "btn btn-bumblebee btn-doorder btn-doorder-primary btn-doorder-submit",
              cancelButton:
                "btn btn-bumblebee btn-doorder btn-doorder-danger-outline btn-doorder-submit",
            },
            // timer: 3000,
          }).then((r) => {
            // console.log(r.value);
          });
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/doorder/retailers/SingleRequest.vue